import { render, staticRenderFns } from "./follow-action.vue?vue&type=template&id=077ec73b&"
import script from "./follow-action.vue?vue&type=script&lang=js&"
export * from "./follow-action.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports